/* import __COLOCATED_TEMPLATE__ from './list.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import { type OptimizeSuggestionItem } from 'embercom/services/optimize-suggestions-service';
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    suggestions: OptimizeSuggestionItem[];
    activeContentId?: string;
    activeContentType?: string;
    showTopics?: boolean;
  };
}
const List = templateOnlyComponent<Signature>();
export default List;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::List': typeof List;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/list': typeof List;
  }
}
